/**
 * Supabase 客户端配置
 */
import { createClient } from '@supabase/supabase-js';
import type { Session } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase 配置缺失，请设置 REACT_APP_SUPABASE_URL 和 REACT_APP_SUPABASE_ANON_KEY'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  },
});

let lastRealtimeToken: string | null = null;
let authBridgeInitialized = false;

function syncRealtimeAuth(session: Session | null) {
  const token = session?.access_token || null;
  if (!token || token === lastRealtimeToken) {
    if (!token) {
      lastRealtimeToken = null;
    }
    return;
  }

  supabase.realtime.setAuth(token);
  lastRealtimeToken = token;
}

function initRealtimeAuthBridge() {
  if (authBridgeInitialized) return;
  authBridgeInitialized = true;

  supabase.auth.getSession()
    .then(({ data }) => {
      syncRealtimeAuth(data.session);
    })
    .catch((error) => {
      console.warn('初始化 Realtime 鉴权失败:', error);
    });

  supabase.auth.onAuthStateChange((_event, session) => {
    syncRealtimeAuth(session);
  });
}

if (typeof window !== 'undefined') {
  initRealtimeAuthBridge();
}
